export default "__VITE_ASSET__47c579b6__"